import React from 'react'
import { observer } from 'mobx-react'
import { useToggle } from 'hooks/state-hooks'
import FilterControls from 'infra/FilterControls'
import { TableSearchbar } from 'payouts/components/TableSearchbar'
import { ClientUserManagementViewModel } from 'client-user-management/views/ClientUserManagement/ClientUserManagementViewModel'

interface TableControlsProps {
  vm: ClientUserManagementViewModel
}

function ClientUserManagementTableControls({ vm }: TableControlsProps) {
  const userSearchVM = vm.userSearch
  const hasFilters = userSearchVM.filters.appliedFilterCount > 0
  const showingFilterControls = useToggle(hasFilters)

  return (
    <>
      <TableSearchbar
        disabled={false}
        searchText={userSearchVM.searchText.value}
        onSearchTextChange={userSearchVM.searchText.change}
      />

      <FilterControls
        active={showingFilterControls.isEnabled}
        vm={userSearchVM.filters}
      />
    </>
  )
}

export default observer(ClientUserManagementTableControls)
